<template>
  <div id="cat" v-cloak>
    <div class="vx-card">
      <div class="vx-card__body card-body">
        <div class="vx-row mb-4">
          <div class="vx-col">
            <vs-button @click="isCreateProvince()" class="bg_l_green" v-has-permission="'CreateProvince'">
              <feather-icon icon="PlusIcon" svgClasses="h-4 w-4" class="ico" />
              {{ $t("CreateProvince") }}
            </vs-button>
          </div>
        </div>
        <create-popup
          :show="showCreateProvince"
          @finish="onfinish"
        ></create-popup>
        <modify-popup
          :show="showModifyProvince"
          :ProvinceForModify="ProvinceForModify"
          @finish="onfinish"
        ></modify-popup>
        <div class="vx-row">
          <div class="vx-col w-full mb-base">
            <data-grid
              ref="grid"
              stripe
              :data-source="gridDataSource"
              :search-data="gridSearchData"
              :columns="[
                { title: $t('ProvinceName') },
                { title: $t('Priority') },
                { title: $t('CreateOn') },
                { title: $t('Action') },
              ]"
            >
              <template slot-scope="{ row }">
                <td style="width: 20%">
                  {{ row.name }}
                </td>
                <td style="width: 20%">
                  {{ row.priority }}
                </td>
                <td style="width: 30%">
                  {{ row.createOn }}
                </td>

                <td style="width: 30%">
                  <vs-button
                    radius
                    color="success"
                    size="small"
                    type="gradient"
                    icon-pack="feather"
                    icon="icon-edit"
                    v-has-permission="'ModifyProvince'"
                    @click.prevent="isModifyProvince(row)"
                    class="d-inline"
                  ></vs-button>
                  <vs-button
                    radius
                    color="danger"
                    size="small"
                    type="gradient"
                    icon-pack="feather"
                    icon="icon-x"
                    v-has-permission="'DeleteProvince'"
                    @click.prevent="isDeleteProvince(row)"
                    class="d-inline mx-4"
                  ></vs-button>
                </td>
              </template>
            </data-grid>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import "@/assets/scss/vuesax-rtl/pages/_custom.scss";
import DataGrid from "@/components/datagrid/DataGrid";
import CreatePopup from "./CreatePopup.vue";
import ModifyPopup from "./ModifyPopup.vue";

export default {
  name: "",
  components: {
    CreatePopup,
    ModifyPopup,
    DataGrid,
  },
  data() {
    return {
      showCreateProvince: false,
      showModifyProvince: false,
      gridDataSource: {
        type: "app",
        service: "Geography/api/CountriesQuery/provinces",
      },
      gridSearchData: {},
      ProvinceForModify: {},
    };
  },
  computed: {
    ...mapGetters({
      allCountries: "country/countryList",
    }),
  },
  mounted() {
    this.fetchCountry();
  },
  methods: {
    ...mapActions({
      deleteProvince: "country/removeProvince",
      fetchCountry: "country/fetchCountry",
    }),
    isCreateProvince() {
      this.showCreateProvince = true;
    },
    onfinish() {
      this.showCreateProvince = false;
      this.showModifyProvince = false;
      this.$refs.grid.renderGrid();
    },
    isModifyProvince(Province) {
      this.ProvinceForModify.id = Province.id;
      this.ProvinceForModify.name = Province.name;
      this.ProvinceForModify.priority = Province.priority;
      this.ProvinceForModify.parentId = this.allCountries.find(
        (x) => x.id === Province.parentId
      );
      this.showModifyProvince = true;
    },
    isDeleteProvince(Province) {
      this.$swal({
        title: "آیا از حذف این رکورد اطمینان دارید؟",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "بلی",
        cancelButtonText: "خیر",
      }).then((result) => {
        if (result.value) {
          this.deleteProvince(Province.id).then(() => {
            this.$refs.grid.renderGrid();
          });
        }
      });
    },
  },
};
</script>
